export const getQuery = (mediaCommand) => {
  return mediaCommand.replace("@media ", "");
};
